<template>
  <div class="admin">
    <div class="toolbar container">
      <router-link
        v-if="user.accountType === 'Root'"
        :to="{ name: 'addRateCards' }"
        id="rateCards"
        >{{ parseTranslation(MANAGE_RATE_CARDS) }}</router-link
      >
      <router-link
        v-if="user.accountType === 'Root'"
        :to="{ name: 'addgroup' }"
        id="group"
        >{{ parseTranslation(MANAGE_GROUPS) }}</router-link
      >
      <router-link
        v-if="
          !$store.getters.firstAccess &&
            (user.accountType === 'Root' || user.accountType === 'VzAdmin')
        "
        :to="{ name: 'user' }"
        id="user"
        >{{ parseTranslation(MANAGE_USERS) }}</router-link
      >
      <router-link
        v-if="user.accountType === 'Root' || user.accountType === 'VzAdmin'"
        :to="{ name: 'survey' }"
        id="survey"
        >{{ parseTranslation(MANAGE_SURVEYS) }}</router-link
      >
      <router-link
        v-if="user.accountType === 'Root'"
        :to="{ name: 'history' }"
        id="history"
        >{{ parseTranslation(HISTORY) }}</router-link
      >
      <router-link :to="{ name: 'password' }" id="change">{{
        translations[language][CHANGE_PASSWORD]
      }}</router-link>
    </div>
    <router-view :users="users" :toggle_user_status="toggleUserStatus" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationAdmin from './index.translations'

const { default: translations, ...translationKeys } = translationAdmin

export default {
  name: 'admin',
  data() {
    return {
      translations,
      ...translationKeys,
      user: this.$store.getters.user,
    }
  },

  computed: {
    users() {
      return this.$store.getters.users
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall', 'setUsers']),

    async getUsers() {
      const { accountType } = this.user

      if (accountType !== 'Root' && accountType !== 'VzAdmin') return

      const users = await this.executeSurveyAPICall({
        path: 'user/admin/list',
      })

      if (!users) return

      this.setUsers(users)
    },

    toggleUserStatus(username) {
      const updatedUsers = this.users.map(user => {
        if (user.username !== username) return user

        return {
          ...user,
          disabled: !user.disabled,
        }
      })

      this.setUsers(updatedUsers)
    },
  },

  mounted() {
    this.getUsers()
  },
}
</script>

<style lang="scss" scoped>
.toolbar {
  border-radius: 3px 3px 0 0;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  @include d(s) {
    flex-direction: column;
  }
  a {
    @include tipography(20);
    padding: 10px;
    font-weight: bold;
    margin-right: 30px;
    @include d(s) {
      margin-right: 0;
    }
    color: $gray;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    &:hover {
      color: $white;
      &::after {
        min-width: 100%;
        color: $secondary-two;
      }
    }
    &::after {
      content: '';
      height: 2px;
      width: auto;
      min-width: 0px;
      color: transparent;
      background-image: linear-gradient(
        to right,
        transparent,
        currentColor 50%,
        transparent
      );
      display: block;
      border-radius: 3px;
      position: relative;
      top: 13px;
      transition: min-width 0.35s cubic-bezier(0.05, 0.385, 0.32, 1.275);
    }
    &.router-link-exact-active,
    &.router-link-active {
      color: $white;
      &::after {
        @include d(s) {
          color: transparent;
        }
        color: $secondary-two;
        min-width: 100%;
      }
    }
    &[href='/'].router-link-active {
      color: $gray;
      &::after {
        @include d(s) {
          color: rgba(0, 0, 0, 0);
        }
        color: $secondary-two;
        min-width: 0px;
      }
      &:hover {
        &::after {
          min-width: 100%;
        }
      }
      &.router-link-exact-active {
        color: $white;
        &::after {
          @include d(s) {
            color: transparent;
          }
          color: $secondary-two;
          min-width: 100%;
        }
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .light & {
    a {
      &:hover,
      &.router-link-exact-active,
      &.router-link-active {
        color: $gray-6;
      }
    }
  }
}
</style>
